import { Directive, Input, OnChanges, SimpleChanges, NgZone } from '@angular/core';
import { zip } from 'rxjs';
import { UIAwesomeMarkerService, AMapUIAwesomeMarker } from './ui-awesome-marker.service';
import { UISimpleMarker, SimpleMarkerOptions } from '../ui-simple-marker/ui-simple-marker';
import { getOptions, ChangeFilter } from '../../utils';
import { EventBinderService } from '../../shared/event-binder.service';
import { AMapService } from '../../shared/amap.service';
import { PixelService } from '../../shared/pixel.service';
import { IconService } from '../../shared/icon.service';
import { MarkerLabelService } from '../../shared/marker-label.service';
import { LoggerService } from '../../shared/logger/logger.service';

const AwesomeMarkerOptions = [...SimpleMarkerOptions, 'awesomeIcon', 'getClassnamesOfAwesomeIcon'];

@Directive({
  selector: 'ui-awesome-marker',
  exportAs: 'awesomeMarker',
  providers: [UIAwesomeMarkerService],
})
export class UIAwesomeMarkerDirective extends UISimpleMarker implements OnChanges {
  TAG = 'ui-awesome-marker';
  // ---- Options ----
  /**
   * icon çåç§°ï¼å¯ç¨ç icons åè§ Font Awesome å®ç½
   */
  @Input() awesomeIcon: string;
  /**
   * è¿åå­ä½èç¹ä¸ç classNames
   */
  @Input() getClassnamesOfAwesomeIcon: (icon: string) => string;

  constructor(
    protected os: UIAwesomeMarkerService,
    protected binder: EventBinderService,
    protected amaps: AMapService,
    protected pixels: PixelService,
    protected icons: IconService,
    protected mlabels: MarkerLabelService,
    protected logger: LoggerService,
    protected ngZone: NgZone,
  ) {
    super(os, binder, amaps, pixels, icons, mlabels, logger, ngZone);
  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    const filter = ChangeFilter.of(changes);
    const marker = this.get();
    if (this.inited) {
      zip(filter.has<string>('awesomeIcon'), marker).subscribe(([v, m]) => m.setAwesomeIcon(v));
    }
  }

  getOptions() {
    return getOptions<AMapUIAwesomeMarker.Options>(this, AwesomeMarkerOptions);
  }
}
